import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './style.css'
import App from './App.vue'
import router from './router'

const app = createApp(App)

// Register Element Plus with Chinese locale
app.use(ElementPlus, {
  locale: zhCn
})

// Register all Element Plus icons globally
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.mount('#app')

// ============ HTTPS SECURITY DIAGNOSIS (Production Only) ============
if (import.meta.env.PROD && window.location.protocol === 'https:') {
  // Run security check after a short delay to ensure all resources are loaded
  setTimeout(async () => {
    try {
      const { performHttpsSecurityCheck } = await import('./utils/httpsDiagnostic')
      
      const result = await performHttpsSecurityCheck()
      
      if (!result.isSecure) {
      }
    } catch (error) {
    }
  }, 2000)
}
